import { render, staticRenderFns } from "./CustomerGiveaways.vue?vue&type=template&id=e2c48f78&"
import script from "./CustomerGiveaways.vue?vue&type=script&lang=js&"
export * from "./CustomerGiveaways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports